import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { H3 } from "../text"
import View from "../view"

export const Dropdown2 = ({ title, label, value, onChange, options }) => {
  return (
    <View style={{ marginTop: 0 }}>
      <H3>{title}</H3>

      <FormControl
        size="small"
        sx={{ minWidth: 220, maxWidth: 280, alignSelf: 'flex-start' }}
      >
        <InputLabel>{label}</InputLabel>

        <Select
          value={value}
          label={label}
          onChange={onChange}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </View>
  )
}